import { render, staticRenderFns } from "./DetailPageLayout.vue?vue&type=template&id=74176f62&scoped=true&"
import script from "./DetailPageLayout.vue?vue&type=script&lang=js&"
export * from "./DetailPageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74176f62",
  null
  
)

export default component.exports